import { ORGANIZATION_FORM_KEYS } from '@/consts/organizationForm';
import { IOrganizationFormData } from '@/content/components/common/Form/OrganizationForm/schema';
import { IOrganization } from '@/services/organizations/types';

const {
  NAME,
  COUNTRY,
  STREET,
  PROVINCE,
  POSTAL,
  OWNER_EMAIL,
  LOGO,
} = ORGANIZATION_FORM_KEYS;

function buildOrganizationFormValuesFromOrganization(
  data: IOrganization | undefined,
): IOrganizationFormData {
  return {
    [NAME]: data?.name ?? '',
    [COUNTRY]: data?.billingAddress?.country ?? '',
    [STREET]: data?.billingAddress?.street ?? '',
    [PROVINCE]: data?.billingAddress?.province ?? '',
    [POSTAL]: data?.billingAddress?.postalCode ?? '',
    [OWNER_EMAIL]: data?.owner?.email ?? '',
    [LOGO]: null,
  };
}

export default buildOrganizationFormValuesFromOrganization;
